var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 36","width":_vm.length,"height":_vm.length}},[_c('title',[_vm._v(_vm._s(_vm.alt))]),_c('circle',{attrs:{"cx":"18","cy":"18","r":"16","fill":"#D8D8D8"}})])}
var staticRenderFns = []

export { render, staticRenderFns }